import React, { useState, useMemo } from 'react';
import { useHistory, useParams } from 'react-router';
import { useQuery } from 'apollo-3';

import { Flex } from 'Components/Base';
import { PATHS } from 'Routes/Main/paths';
import { getGuidedPracticeExamPaper } from 'GraphQL/query/GuidedPractice.query';
import Loading from 'Components/Loading';
import Header from 'Routes/GuidedPractice/Components/Header';
import { EXAM_PAPER_TYPE } from 'Context/ExamRoomContext/mapper';

import ExamResultItem from './ExamResultItem';
import ExamResultList from './ExamResultList';

const ExamResults = () => {
  const history = useHistory();
  const { sessionId } = useParams();
  const [examResultSelected, setExamResultSelected] = useState(null);
  const { data, loading } = useQuery(getGuidedPracticeExamPaper, {
    variables: { examSessionId: sessionId },
    fetchPolicy: 'network-only',
  });

  const examPaperItemViews = useMemo(() => {
    if (!data) return [];
    let questionCounter = 0;
    return data.guidedPracticeExamPaper.examPaperItemViews.map((item) => {
      if (item.type === EXAM_PAPER_TYPE.QUESTION) {
        questionCounter += 1;
        return { ...item, questionNo: questionCounter };
      }
      return item;
    });
  }, [data]);

  const handleNextExamItem = () => {
    const currentIndex = examPaperItemViews.findIndex((item) => item.id === examResultSelected.id);
    const nextIndex = currentIndex + 1;
    if (nextIndex < examPaperItemViews.length) {
      setExamResultSelected(examPaperItemViews[nextIndex]);
    } else {
      setExamResultSelected(null);
    }
  };

  const questionItems = useMemo(
    () => examPaperItemViews.filter((item) => item.type === EXAM_PAPER_TYPE.QUESTION),
    [examPaperItemViews]
  );

  const currentQuestionNumber = useMemo(() => {
    if (!examResultSelected || examResultSelected.type !== EXAM_PAPER_TYPE.QUESTION) return 0;
    return questionItems.findIndex((item) => item.id === examResultSelected.id) + 1;
  }, [examResultSelected, questionItems]);

  if (loading) return <Loading width={100} height={100} />;

  return (
    <Flex
      data-testid={'exam-results'}
      height={'100vh'}
      overflow={'hidden'}
      flexDirection={'column'}
    >
      <Header onClose={() => history.replace(PATHS.guidedPractice)} />
      {examResultSelected ? (
        <ExamResultItem
          examResultSelected={examResultSelected}
          setExamResultSelected={setExamResultSelected}
          totalQuestionAmount={questionItems.length}
          currentQuestionNumber={currentQuestionNumber}
          onNext={handleNextExamItem}
        />
      ) : (
        <ExamResultList
          examPaperItemViews={examPaperItemViews}
          setExamResultSelected={setExamResultSelected}
        />
      )}
    </Flex>
  );
};

export default ExamResults;
